export function formatFamilyName(name) {
    return name.split("(")[0].trim();
}
